// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BzC4","importantInfo":"styles_importantInfo__WTsZ_"};